{"rating":"4.9","reviewCount":"141","fetchedAt":"2026-10-16T06:18:41.505Z","source":"place-details"}